// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aD5JB"};